import { supplierIdFormat } from "@redotech/redo-ids-cockroach";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const getSupplierProductsCount = {
  name: "getSupplierProductsCount" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ totalCount: z.number().int() }),
};
